import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { AttributeWidth } from '../../../../../../Components/Attributes/Utils/AttributeValueAutoSizeUtils';

interface IProps {
  displayLabel: string;
  value?: string;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    minWidth: AttributeWidth.small, // Temp tills hantering av width har tänkts igenom
    height: 72,
    position: 'relative',
  },
  labelStyle: {
    fontSize: theme.typography.pxToRem(12),
    paddingTop: 16,
  },
  infoButton: {
    margin: '0 0 0 4px',
    padding: 0,
    position: 'absolute',
    top: 10,
  },
});

const AssociationHeaderBase = (props: IProps) => {
  return (
    <div className={props.classes.container}>
      <div className={props.classes.labelStyle}>
        <span>{props.displayLabel}</span>
      </div>
      <EDTypography color="inherit" bold>
        <span>{props.value ? props.value : '-'}</span>
      </EDTypography>
    </div>
  );
};

export const AssociationHeader = withStyles(AssociationHeaderBase, styles);
